export default __webpack_public_path__ + "static/media/Rahul.6a5a8d73.jpg";